export const AppConfig = {
  env: process.env.NODE_ENV,
  baseUrl: process.env.REACT_APP_BASE_URL || "https://test.dealershub.ca",
  apiBaseUrl:
    process.env.REACT_APP_API_BASE_URL || "https://app.test.dealershub.ca",
  googleClientId:
    process.env.REACT_APP_GOOGLE_CLIENT_ID ||
    "243700972628-3f6qq6t38lcg4n2lglhiqtt5e5tnhma2.apps.googleusercontent.com",
};
